import React from 'react';
import ArrowNarrowLeft from '@/components/icons/arrow-narrow-left';
import classNames from 'classnames';
import { useIsRTL } from '@/lib/locals';
import { useAtom } from 'jotai';
import { useDrawer } from '@/components/ui/drawer/useDrawer';
import { drawerAtom } from '@/store/drawer-atom';
import { searchDrawerAtom } from '@/store/searchDrawerAtom';

const FilterHeader = () => {
const { isRTL } = useIsRTL();

  const [_, closeSidebar] = useAtom(drawerAtom);
  const { closeDrawer } = useDrawer({ atom: searchDrawerAtom });

  const closeDrawers = () => {
    closeSidebar({ display: false, view: '' });
    closeDrawer();
  };

  return (
    <div className="sticky top-0 z-10 flex items-center justify-between rounded-tl-xl rounded-tr-xl border-b bg-white px-5 py-4 lg:py-3 lg:static lg:hidden">
      <div className="flex items-center space-x-3 rtl:space-x-reverse lg:space-x-0">
        <button type="button"
          className="text-body focus:outline-0 lg:hidden"
          onClick={closeDrawers}
        >
          <ArrowNarrowLeft
            className={classNames('h-7', {
              'rotate-180': isRTL,
            })}
            strokeWidth={1.7}
          />
          <span className="sr-only">{"fechar"}</span>
        </button>

        <h3 className="text-xl font-semibold text-gray-200">
          <span className="lg:hidden">{"Voltar"}</span>
          <span className="hidden lg:inline">{"Filtrar"}</span>
        </h3>
      </div>
    </div>
  );
};

export default FilterHeader;
